import { InjectionToken } from "@angular/core";

export const AUTH_SERVICE_URL_TOKEN = new InjectionToken<string>("AUTH_SERVICE_URL_TOKEN");
